import { render, staticRenderFns } from "./CustomNotifications.vue?vue&type=template&id=92f8dbc4&"
import script from "./CustomNotifications.vue?vue&type=script&lang=js&"
export * from "./CustomNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports